module.exports = __webpack_public_path__ + "static/media/afiche1920.738ca85c.jpg";